import actions from '@/modules/upcoming/store/actions'
import getters from '@/modules/upcoming/store/getters'
import mutations from '@/modules/upcoming/store/mutations'

export default {
  state: () => ({}),
  actions: actions,
  getters: getters,
  mutations: mutations
}
